<template>
    <div class="infoCard">
        <b-card header="header" class="subInfo"> 
            <template v-slot:header  >
                <h6> {{$t('signal.alarmStatus.accountAlarmStates')}} </h6>
            </template>
            <b-table-simple>
                <b-thead>
                    <b-th> {{$t('signal.alarmStatus.signalType')}}  </b-th>
                    <b-th> {{$t('signal.alarmStatus.status')}} </b-th>
                </b-thead>
                <b-tbody>
                     <b-tr v-for="alert in data.account_info.account_alerts" :key="alert.id"> 
                        <b-td> {{alert.signal_info.name}} </b-td>
                        <b-td> 
                            <b-badge v-if="alert.is_alert" variant="danger"> {{$t('signal.alarmStatus.alarm')}} </b-badge> 
                            <b-badge v-else variant="success"> {{$t('signal.alarmStatus.allSignals')}} </b-badge> 
                        </b-td>

                    </b-tr>
               
                </b-tbody>
            </b-table-simple>
        </b-card>
        <b-card header="header" class="subInfo"> 
            <template v-slot:header  >
                <h6> {{$t('signal.alarmStatus.accountNotificationStates')}} </h6>
            </template>
            <b-table-simple>
                <b-thead>
                    <b-th> {{$t('signal.alarmStatus.signalType')}} </b-th>
                    <b-th> {{$t('signal.alarmStatus.alarmSending')}} </b-th>
                    <b-th> {{$t('signal.alarmStatus.account')}} </b-th>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="not in notifications" :key="not.id"> 
                        <b-td> {{not.signal_group_def.code}} - {{not.signal_group_def.name}}  </b-td>
                        <b-td> <b-badge variant="info"> {{not.sys_module_info.name}} </b-badge> </b-td>
                        <b-td> {{not.account_user_info.name}}  </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-card>
         <b-card header="header" class="subInfo"> 
            <template v-slot:header  >
                <h6> {{$t('signal.alarmStatus.subscriptions')}} </h6>
            </template>
            <b-table-simple>
                <b-thead>
                    <b-th> {{$t('signal.alarmStatus.subName')}} </b-th>
                    <b-th> {{$t('signal.alarmStatus.beginDate')}} </b-th>
                    <b-th> {{$t('signal.alarmStatus.endDate')}} </b-th>
                    <b-th> {{$t('signal.alarmStatus.status')}} </b-th>

                </b-thead>
                <b-tbody>
                     <b-tr v-for="sub in data.account_info.account_info.customer.subs" :key="sub.id"> 
                        <b-td> {{sub.sub.name}} </b-td>
                        <b-td> {{dateFormat(sub.begin_date)}} </b-td>
                        <b-td> {{dateFormat(sub.end_date)}} </b-td>
                        <b-td> 
                            <b-badge v-if="compareDate(sub.end_date) == true" :id="'sub'+sub.id" variant="success"> {{$t('signal.alarmStatus.continues')}} </b-badge> 
                            <b-badge v-else-if="compareDate(sub.end_date) == false" :id="'sub'+sub.id" variant="danger"> {{$t('signal.alarmStatus.expired')}} </b-badge> 
                            <b-badge v-else :id="'sub'+sub.id" variant="warning"> {{compareDate(sub.end_date)}} {{$t('signal.alarmStatus.expiredIn')}} </b-badge> 
                        </b-td>

                    </b-tr>
               
                </b-tbody>
            </b-table-simple>
        </b-card>
       <b-card header="header" class="subInfo"> 
            <template v-slot:header  >
                <h6> {{$t('signal.alarmStatus.followedStates')}} </h6>
            </template>
            <b-table-simple>
                <b-thead>
                    <b-th> {{$t('signal.alarmStatus.name')}}  </b-th>
                    <b-th> {{$t('signal.alarmStatus.status')}} </b-th>
                    <b-th> {{$t('signal.alarmStatus.beginDate')}} </b-th>
                </b-thead>
                <b-tbody>
                     <b-tr v-for="tracking in data.account_info.tracking_list" :key="tracking.id"> 
                        <b-td> {{tracking.control_info.name}} </b-td>
                        <b-td> 
                            <b-badge v-if="tracking.is_control" variant="success"> {{$t('signal.alarmStatus.beingFollowed')}} </b-badge> 
                            <b-badge v-else variant="danger"> {{$t('signal.alarmStatus.notFollowed')}} </b-badge> 
                        </b-td>
                        <b-td> {{dateFormat()}} </b-td>

                    </b-tr>
               
                </b-tbody>
            </b-table-simple>
        </b-card>
    </div>
    
</template>

<script>
    import moment from 'moment'
    export default {
        name: "GeneralInfo",
         props:{
            data: Object
        },
        created: function(){
            this.$store.dispatch('notification_get', {parent_id: this.data.account_info.ID })

        },
        computed:{
            notifications(){
                return this.$store.getters.getAccountNotifications
            }
        },
        methods:{
            dateFormat(val){
                return moment(String(val)).format('DD.MM.YYYY') 
            },
            compareDate(val){
                let active = moment().isBefore(val)
                if(active){
                    let diff = moment(val).diff(moment(),'days') 
                   if(diff > 30){
                       return true
                   }else{
                       return diff
                   }
                }else{
                    return false
                    
                }
                
            }
        }
    }
</script>

<style scoped>
    @import "../styles/generalInfo.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/components/AlarmStatus.vue